import { render, staticRenderFns } from "./ConfirmationMailsNav.vue?vue&type=template&id=f222f1f0&"
import script from "./ConfirmationMailsNav.vue?vue&type=script&lang=js&"
export * from "./ConfirmationMailsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports